import React from "react";

export function SelectOption({ children, ...other }) {
  return <option {...other}>{children}</option>;
}
